import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgDelete = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M2.75 4.75h14.5m-10.5 0v-1a2 2 0 0 1 2-2h2.5a2 2 0 0 1 2 2v1m-1 4v5.5m-4.5-5.5v5.5m-4-9.5h12.5l-.645 11.61a2 2 0 0 1-1.997 1.89H6.392a2 2 0 0 1-1.997-1.89L3.75 4.75Z"
	})]
});
const ForwardRef = forwardRef(SvgDelete);
export { ForwardRef as ReactComponent };
